function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

$(".js-sort-by").on("change", function () {
  const selectedValue = this.options[this.selectedIndex];
  Shopify.queryParams = {};
  if (location.search.length) {
    var params = location.search.substr(1).split("&");

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split("=");

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] =
          decodeURIComponent(keyValue[1]);
      }
    }
  }
  Shopify.queryParams.sort_by = selectedValue.value;
  location.search = new URLSearchParams(Shopify.queryParams).toString();

  // const filterForm = $('collection-filter form');
  // const sortBy = filterForm.find('[type="hidden"]');
  // sortBy.val(selectedValue.value);
  // filterForm.find('button[type="submit"]').click();
});
$(document).on("click", ".quantity-box__button", function () {
  const event = new Event("countChange");
  $(this)
    .closest(".quantity-box__wrap")
    .find($("input"))[0]
    .dispatchEvent(event);
});
$(document).on("change", ".js-quantity-input", function () {
  const event = new Event("countChange");
  $(this)[0].dispatchEvent(event);
});

function Update_cart_count() {
  jQuery.getJSON("/cart.js", function (cart) {
    $(".js-cart-count-text")[0].innerHTML = cart.item_count;
    $(".js-cart-count")[0].removeAttribute("style");
  });
}

function updateCartPopup(productForm) {
	if (productForm == true) {
		$(".js-cart-title").html(window.cartStrings.success);
	}

	Update_cart_count();

	$("#cart-form").addClass("loading").attr("aria-busy", "true");

	fetch(window.routes.cart_url + "/?section_id=ajax-cart-popup")
		.then(function (response) {
			return response.text();
		})
		.then(function (html) {
			var parser = new DOMParser();
			var doc = parser.parseFromString(html, "text/html");
			const cart = $(doc).find("#cart-form .cart-modal__inner")[0].innerHTML;

			$(document).find("#cart-form .cart-modal__inner")[0].innerHTML = cart;

			if (productForm == true) {
				$(".js-cart-title")[0].innerHTML = window.cartStrings.success;

				const modalWrapper = document.getElementById("modal-add-to-cart");
				if (modalWrapper) {
					modalWrapper.focus();
				}
			} else {
				const cartAddStatus = document.getElementById("cart-add-status");
				if (cartAddStatus) {
					cartAddStatus.textContent = "";
					window.setTimeout(function () {
						cartAddStatus.textContent = "Cart updated"; // Озвучить оновлення кошика
					}, 50);
				}
			}
			reloadEvents();

			$("#cart-form").removeClass("loading").removeAttr("aria-busy");
		})
		.catch(function (err) {
			console.error("Something went wrong.", err);
			$("#cart-form").removeClass("loading").removeAttr("aria-busy");
		});
}

function reloadEvents() {
  var $block = $(".quantity-box");
  if (!$block.length) {
    return;
  }
  $block.each(function () {
    var $thisBlock = $(this);
    var $control = $thisBlock.find(".quantity-box__button");
    var $field = $thisBlock.find(".quantity-box__value");
    var count = parseInt($field.val());

    $field.on("input", function (e) {
      if (e.target.value <= 0) {
        $field.val("1");
      }
      $field.val(e.target.value.replace(/[, .]/g, ""));
    });

    $control.on("click", function () {
      if ($(this).is(".quantity-box__button_plus")) {
        count += 1;
      }
      if ($(this).is(".quantity-box__button_minus") && count > 1) {
        count -= 1;
      }
      $field.val(count);
    });
  });
}

let teamModalRestoreFocusTarget = null;

function restoreTeamModalFocus() {
  const target = teamModalRestoreFocusTarget;

  if (!target || !document.contains(target)) return;

  window.requestAnimationFrame(() => {
    window.setTimeout(() => {
      target.focus({ preventScroll: true });
      teamModalRestoreFocusTarget = null;
    }, 0);
  });
}

$(document).on("hidden.bs.modal", "#modal-inform-team", restoreTeamModalFocus);

function focusSuccessModal(modal) {
  const focusTarget =
    modal.querySelector(".success-modal__title") ||
    modal.querySelector(".success-modal__button") ||
    modal;

  window.requestAnimationFrame(() => {
    window.setTimeout(() => {
      focusTarget.focus({ preventScroll: true });
    }, 0);
  });
}

$(document).on("shown.bs.modal", "#modal-success", function () {
  focusSuccessModal(this);
});

function initContactSuccessModalFocus() {
  const searchParams = new URLSearchParams(window.location.search);
  const isContactPosted = searchParams.get("contact_posted") === "true";
  const isContactFormHash = ["#CustomerSupport", "#Distributor"].includes(
    window.location.hash
  );
  const modal = document.getElementById("modal-success");

  if (!isContactPosted || !isContactFormHash || !modal) return;

  window.setTimeout(() => {
    if (typeof $(modal).modal === "function") {
      $(modal).modal("show");
    }

    focusSuccessModal(modal);
  }, 600);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initContactSuccessModalFocus, {
    once: true,
  });
} else {
  initContactSuccessModalFocus();
}

$(document).on("click", ".js-team-read-more", function (e) {
  e.preventDefault();

  const modalId = $(this).attr("data-modal-id");
  const modal = $(`#${modalId}`);
  const item = $(this).closest(".js-team-item");
  const name = item.find(".slide-card__title");
  const lable = item.find(".slide-card__label");
  const text = item.find(".modal-text");
  const trigger = this;
  const restoreFocusTarget = this.closest(".slide-card") || trigger;
  teamModalRestoreFocusTarget = restoreFocusTarget;

  modal.find(".inform-modal__title")[0].innerHTML = name[0].innerHTML;
  modal.find(".inform-modal__subtitle")[0].innerHTML = lable[0].innerHTML;
  modal.find(".inform-modal__text")[0].innerHTML = text[0].innerHTML;

  modal
    .off("shown.bs.modal.teamFocus")
    .one("shown.bs.modal.teamFocus", function () {
      const closeButton = this.querySelector("[data-dismiss='modal']");
      const focusTarget = closeButton || this.querySelector(".modal-content") || this;
      focusTarget.focus();
    });

  if (typeof modal.modal === "function") {
    modal.modal("show", trigger);
  } else {
    $(".js-popup-triger")[0].click();
  }
});

let mobileFiltersRestoreFocusTarget = null;

function focusMobileFilters() {
  const filtersMobile = document.querySelector(".filters-mobile");
  const filtersPanel = filtersMobile?.querySelector(".page-layout__aside-content");
  const closeButton = filtersMobile?.querySelector(".filters__nav-close");

  if (!filtersMobile) return;

  filtersMobile.setAttribute("tabindex", "-1");
  filtersMobile.setAttribute("role", "dialog");
  filtersMobile.setAttribute("aria-modal", "true");

  if (filtersPanel && !filtersPanel.hasAttribute("tabindex")) {
    filtersPanel.setAttribute("tabindex", "-1");
  }

  window.setTimeout(() => {
    (closeButton || filtersMobile).focus({ preventScroll: true });
  }, 350);
}

function closeMobileFilters() {
  if (!document.body.classList.contains("filters-opened")) return;

  document.body.classList.remove("filters-show");

  window.setTimeout(() => {
    document.body.classList.remove("filters-opened");
  }, 300);
}

function restoreMobileFiltersFocus() {
  const target = mobileFiltersRestoreFocusTarget;
  const filtersMobile = document.querySelector(".filters-mobile");

  filtersMobile?.removeAttribute("role");
  filtersMobile?.removeAttribute("aria-modal");

  if (!target || !document.contains(target)) return;

  window.setTimeout(() => {
    target.focus({ preventScroll: true });
    mobileFiltersRestoreFocusTarget = null;
  }, 350);
}

$(document).on(
  "click",
  ".page-layout__aside-nav-item_filter > .page-layout__aside-nav-button",
  function () {
    mobileFiltersRestoreFocusTarget = this;
    focusMobileFilters();
  }
);

$(document).on("click", ".filters-mobile__backdrop, .filters__nav-close", function () {
  restoreMobileFiltersFocus();
});

$(document).on("keydown", function (event) {
  if (event.key === "Escape" && document.body.classList.contains("filters-show")) {
    event.preventDefault();
    closeMobileFilters();
    restoreMobileFiltersFocus();
  }
});

$(".js-search-sort-by").on("change", function () {
  const value = $(this).val();
  Shopify.queryParams = {};
  if (location.search.length) {
    var params = location.search.substr(1).split("&");

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split("=");

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] =
          decodeURIComponent(keyValue[1]);
      }
    }
  }
  Shopify.queryParams.sort_by = value;
  location.search = new URLSearchParams(Shopify.queryParams).toString();
});
$(function () {
  var $block = $(".js-validation-wrap");
  if (!$block.length) {
    return;
  }

  var normalizeText = function (value) {
    return (value || "").replace(/\s+/g, " ").replace(/\*/g, "").trim();
  };

  var fillTemplate = function (template, replacements) {
    var result = template || "";
    Object.keys(replacements).forEach(function (placeholder) {
      result = result.split(placeholder).join(replacements[placeholder]);
    });
    return result;
  };

  var getFieldLabel = function ($field) {
    var accessibilityStrings = window.accessibilityStrings || {};
    var explicitLabel = normalizeText($field.attr("data-validation-label"));
    if (explicitLabel) {
      return explicitLabel;
    }

    var fieldId = $field.attr("id");
    if (fieldId) {
      var $label = $('label[for="' + fieldId + '"]').first();
      var labelText = normalizeText($label.text());
      if (labelText) {
        return labelText;
      }
    }

    var ariaLabel = normalizeText($field.attr("aria-label"));
    if (ariaLabel) {
      return ariaLabel;
    }

    var placeholder = normalizeText($field.attr("placeholder"));
    if (placeholder) {
      return placeholder;
    }

    return accessibilityStrings.validationDefaultFieldLabel || "This field";
  };

  var getFieldFormat = function ($field) {
    return normalizeText($field.attr("data-validation-format")) || "";
  };

  var getRequiredSuggestion = function ($field) {
    var accessibilityStrings = window.accessibilityStrings || {};
    var explicitSuggestion = normalizeText(
      $field.attr("data-validation-suggestion")
    );
    if (explicitSuggestion) {
      return explicitSuggestion;
    }

    var fieldType = ($field.attr("type") || "").toLowerCase();
    if (fieldType === "email") {
      return (
        accessibilityStrings.validationSuggestionEmail ||
        "Enter an email address in the format name@example.com."
      );
    }

    if (fieldType === "tel") {
      var telFormat = getFieldFormat($field) || normalizeText($field.attr("data-mask"));
      if (telFormat) {
        return accessibilityStrings.validationSuggestionTelFormatTemplate
          ? fillTemplate(accessibilityStrings.validationSuggestionTelFormatTemplate, {
              "__WT_FORMAT__": telFormat,
            })
          : "Enter it in the format " + telFormat + ".";
      }
      return (
        accessibilityStrings.validationSuggestionTelGeneric ||
        "Enter a phone number that includes the country or area code if needed."
      );
    }

    if ($field.is("select")) {
      return (
        accessibilityStrings.validationSuggestionSelect ||
        "Select an option from the list."
      );
    }

    return "";
  };

  var getValidationMessage = function ($field, errorType) {
    var accessibilityStrings = window.accessibilityStrings || {};
    var label = getFieldLabel($field);
    var explicitMessage = normalizeText(
      $field.attr("data-validation-" + errorType + "-message")
    );
    if (explicitMessage) {
      return explicitMessage;
    }

    if (errorType === "required") {
      var requiredMessage = accessibilityStrings.validationFieldRequiredTemplate
        ? fillTemplate(accessibilityStrings.validationFieldRequiredTemplate, {
            "__WT_FIELD__": label,
          })
        : label + " is required.";

      var requiredSuggestion = getRequiredSuggestion($field);
      return requiredSuggestion
        ? requiredMessage + " " + requiredSuggestion
        : requiredMessage;
    }

    if (errorType === "email") {
      var emailSuggestion =
        getRequiredSuggestion($field) ||
        accessibilityStrings.validationSuggestionEmail ||
        "Enter an email address in the format name@example.com.";

      var invalidFormatMessage = accessibilityStrings.validationFieldInvalidFormatTemplate
        ? fillTemplate(accessibilityStrings.validationFieldInvalidFormatTemplate, {
            "__WT_FIELD__": label,
          })
        : label + " is not in the correct format.";

      return invalidFormatMessage + " " + emailSuggestion;
    }

    if (errorType === "masked") {
      var format = getFieldFormat($field) || normalizeText($field.attr("data-mask"));
      if (format) {
        return accessibilityStrings.validationFieldFormatMismatchTemplate
          ? fillTemplate(accessibilityStrings.validationFieldFormatMismatchTemplate, {
              "__WT_FIELD__": label,
              "__WT_FORMAT__": format,
            })
          : label + " must match the format " + format + ".";
      }
    }

    return accessibilityStrings.validationRequired || "This field is required.";
  };

  var setManagedDescribedBy = function ($field, errorId) {
    if (typeof $field.data("validationOriginalDescribedBy") === "undefined") {
      $field.data(
        "validationOriginalDescribedBy",
        normalizeText($field.attr("aria-describedby"))
      );
    }

    var originalIds = normalizeText(
      $field.data("validationOriginalDescribedBy") || ""
    )
      .split(" ")
      .filter(Boolean);

    if (originalIds.indexOf(errorId) === -1) {
      originalIds.push(errorId);
    }

    $field.attr("aria-describedby", originalIds.join(" "));
  };

  var syncFieldErrorStyles = function ($field, hasError) {
    if (!$field.is("select")) {
      return;
    }

    var $select2Selection = $field
      .siblings(".select2")
      .find(".select2-selection");

    if (!$select2Selection.length) {
      return;
    }

    if (hasError) {
      $select2Selection.attr("aria-invalid", "true");
    } else {
      $select2Selection.removeAttr("aria-invalid");
    }
  };

  var ensureErrorMessage = function ($field, message) {
    var $group = $field.closest(".form-group");
    if (!$group.length) {
      return;
    }
    var errorId =
      $field.data("validationErrorId") ||
      "validation-error-" +
        ($field.attr("id") || Math.random().toString(36).slice(2, 10));

    $field.data("validationErrorId", errorId);

    var $error = $group.find("#" + errorId);
    if (!$error.length) {
      $error = $(
        '<div class="error-message" id="' +
          errorId +
          '" role="alert" aria-live="polite"></div>'
      );
      $group.append($error);
    }

    $error.text(message);
    $error.removeAttr("hidden");
    $field.attr("aria-invalid", "true");
    setManagedDescribedBy($field, errorId);
    $group.addClass("has-error form-has-error");
    syncFieldErrorStyles($field, true);
  };

  var clearFieldError = function ($field) {
    var $group = $field.closest(".form-group");
    if (!$group.length) {
      return;
    }
    var errorId = $field.data("validationErrorId");
    var originalDescribedBy = normalizeText(
      $field.data("validationOriginalDescribedBy") || ""
    );

    $field.removeAttr("aria-invalid");
    if (originalDescribedBy) {
      $field.attr("aria-describedby", originalDescribedBy);
    } else {
      $field.removeAttr("aria-describedby");
    }

    if (errorId) {
      $group.find("#" + errorId).attr("hidden", "hidden").text("");
    }

    $group.removeClass("has-error form-has-error");
    syncFieldErrorStyles($field, false);
  };

  var isEmptyField = function ($field) {
    return normalizeText($field.val()) === "";
  };

  var hasSelectedValue = function ($field) {
    if (!$field.is("select")) {
      return true;
    }

    return normalizeText($field.val()) !== "";
  };

  var isMaskedFieldComplete = function ($field) {
    if (!$field.attr("data-mask")) {
      return true;
    }

    var value = $field.val() || "";
    return value.indexOf("_") === -1;
  };

  var getFieldValidationState = function ($field) {
    var fieldType = ($field.attr("type") || "").toLowerCase();

    if ($field.prop("required") && isEmptyField($field)) {
      return {
        valid: false,
        errorType: "required",
      };
    }

    if ($field.is("select") && $field.prop("required") && !hasSelectedValue($field)) {
      return {
        valid: false,
        errorType: "required",
      };
    }

    if (fieldType === "email" && !isEmptyField($field)) {
      var emailReg = /^.+@.+\..+$/;
      if (!emailReg.test($field.val())) {
        return {
          valid: false,
          errorType: "email",
        };
      }
    }

    if (fieldType === "tel" && $field.attr("data-mask") && !isEmptyField($field)) {
      if (!isMaskedFieldComplete($field)) {
        return {
          valid: false,
          errorType: "masked",
        };
      }
    }

    return {
      valid: true,
      errorType: null,
    };
  };

  var validateForm = function (form) {
    var validation = true;
    var $firstInvalid = $();

    form.find(".has-error, .form-has-error").removeClass(
      "has-error form-has-error"
    );
    form.find("[aria-invalid='true']").removeAttr("aria-invalid");

    form.find("[required]").each(function () {
      clearFieldError($(this));
    });

    form.find("[required], input[type='email'], input[type='tel'][data-mask]").each(
      function () {
      var $field = $(this);
      var fieldValidation = getFieldValidationState($field);

      if (!fieldValidation.valid) {
        validation = false;
        ensureErrorMessage(
          $field,
          getValidationMessage($field, fieldValidation.errorType)
        );
        if (!$firstInvalid.length) {
          $firstInvalid = $field;
        }
      }
    });

    return {
      validation: validation,
      $firstInvalid: $firstInvalid,
    };
  };

  var markFormSubmitting = function (form) {
    var $formWrap = form.closest(".js-validation-wrap");
    $formWrap.addClass("submitting");
    setTimeout(function () {
      $formWrap.removeClass("submitting").addClass("submitted");
    }, 1000);
  };

  $block.find("form").on("submit", function (e) {
    var form = $(this);

    if (form.data("skipValidationOnce")) {
      form.removeData("skipValidationOnce");
      return;
    }

    var validationResult = validateForm(form);

    if (!validationResult.validation) {
      e.preventDefault();
      if (validationResult.$firstInvalid.length) {
        validationResult.$firstInvalid.trigger("focus");
      }
      form.trigger("validation-error", form);
      return;
    }

    markFormSubmitting(form);
    form.trigger("validation-submit", form);
  });

  var $button = $block.find('button:not([name="decline"])');
  $button.on("click", function (e) {
    var form = $(this).closest("form");
    var validationResult = validateForm(form);

    if (!validationResult.validation) {
      e.preventDefault();
      if (validationResult.$firstInvalid.length) {
        validationResult.$firstInvalid.trigger("focus");
      }
      form.trigger("validation-error", form);
      return;
    }

    markFormSubmitting(form);
    form.data("skipValidationOnce", true);
    form.trigger("validation-submit", form);
  });
  $(document).on(
    "input change blur",
    ".has-error input, .has-error textarea, .has-error select, .form-has-error input, .form-has-error textarea, .form-has-error select",
    function (e) {
      var $field = $(e.currentTarget);
      var fieldValidation = getFieldValidationState($field);

      if (fieldValidation.valid) {
        clearFieldError($field);
        return;
      }

      ensureErrorMessage($field, getValidationMessage($field, fieldValidation.errorType));
    }
  );
  var $this = $(this);
  if ($this.find(".validation-wrap").hasClass("submitted")) {
    $this.find("form").get(0).reset();
  }
  $this.find(".has-error").removeClass("has-error");
  $this.find(".validation-wrap").removeClass("submitted");
});

$(".js-product-rating").on("DOMSubtreeModified", function () {
  $(".js-review-link").show();
  const reviewLink = $(".js-review-link");
  const star = $(this)
    .closest(".product-page-wrapper")
    .find(".js-product-rating .loox-rating span");
  if (star.length > 0) {
    reviewLink.find(
      ".card-thumbs__item-count"
    )[0].innerHTML = `(${star[0].innerHTML
      .replace("reviews", "")
      .replace("&nbsp;", "")
      .trim()})`;
  }
});
$(".js-replacement-back").on("click", function (e) {
  $(this).closest(".replacement-box").removeClass("replacement-box_step-2");
  $(this)
    .closest(".replacement-box")
    .find(".replacement-box__search")
    .trigger("reset");
  $(this).closest(".replacement-box__wrap").removeClass("show-results");
});
$(".cart-box__quantity .quantity-box__button").on("click", function () {
  const _this = $(this);
  setTimeout(function () {
    let value = parseInt(
      _this.closest(".cart-box__quantity").find(".quantity-box__value").val()
    );
    if (value > 1) {
      _this
        .closest(".cart-box__quantity")
        .find(".quantity-box__button.quantity-box__button_minus")
        .removeClass("hide-button");
    } else {
      _this
        .closest(".cart-box__quantity")
        .find(".quantity-box__button.quantity-box__button_minus")
        .addClass("hide-button");
    }
  }, 100);
});
$(".js-country-select").on("change", function () {
  let languageCode = `/${Shopify.locale}`;
  if ($(this).val() == "us") {
    window.location.href = "https://woodtrick.com" + location.pathname;
  } else if ($(this).val() == "eu") {
    window.location.href =
      "https://eu.woodtrick.com" + location.pathname.replace(languageCode, "");
    +"?SkipCozyRedirect=yes";
  }
});

/*custom dropdown*/
const selectedAll = document.querySelectorAll(".wrapper-dropdown");
if (selectedAll) {
  var $showHideBlockDesktop = $("[data-show-hide-desktop]");
  var $showHideBlockMobile = $("[data-show-hide-mobile]");
  var customHideBlock = function hideBlock(block) {
    $(block).css({ opacity: 0, visibility: "hidden" });
  };
  var customShowBlock = function showBlock(block) {
    let showBlock = true;
    $("select.select2.select2_lang").each(function () {
      const select2Instance = $(this).data("select2");
      if (select2Instance && select2Instance.isOpen()) {
        showBlock = false;
      }
    });
    if (showBlock) {
      $(block).css({ opacity: 1, visibility: "visible" });
    }
  };
  selectedAll.forEach((selected) => {
    selected.addEventListener("click", () => {
      let trigger = selected.querySelector(".selected-display");

      if (selected.classList.contains("active")) {
        handleDropdown(selected, trigger, false);
        var windowWidth = $(window).innerWidth();
        // eslint-disable-next-line no-unused-expressions
        setTimeout(function () {
          windowWidth <= 767
            ? customShowBlock($showHideBlockMobile)
            : customShowBlock($showHideBlockDesktop);
        }, 100);
      } else {
        let currentActive = document.querySelector(".wrapper-dropdown.active");

        if (currentActive) {
          let anotherTrigger = currentActive.querySelector(".selected-display");
          handleDropdown(currentActive, anotherTrigger, false);
        }

        handleDropdown(selected, trigger, true);

        var windowWidth = $(window).innerWidth();
        // eslint-disable-next-line no-unused-expressions
        windowWidth <= 767
          ? customHideBlock($showHideBlockMobile)
          : customHideBlock($showHideBlockDesktop);
      }
    });
  });

  // check if anything else ofther than the dropdown is clicked
  window.addEventListener("click", function (e) {
    if (e.target.closest(".wrapper-dropdown") === null) {
      closeAllDropdowns();
    }
  });

  // close all the dropdowns
  function closeAllDropdowns() {
    const selectedAll = document.querySelectorAll(".wrapper-dropdown");
    selectedAll.forEach((selected) => {
      let trigger = selected.querySelector(".selected-display");

      handleDropdown(selected, trigger, false);
    });
    var windowWidth = $(window).innerWidth();
    setTimeout(function () {
      windowWidth <= 767
        ? customShowBlock($showHideBlockMobile)
        : customShowBlock($showHideBlockDesktop);
    }, 100);
  }

  // open all the dropdowns
  function handleDropdown(dropdown, trigger, open) {
    if (!trigger) return;
    if (open) {
      trigger.classList.add("rotated");
      trigger.setAttribute("aria-expanded", "true");
      dropdown.classList.add("active");
    } else {
      trigger.classList.remove("rotated");
      trigger.setAttribute("aria-expanded", "false");
      dropdown.classList.remove("active");
    }
  }
}

function getIsoCodeFromSwitcher(countryName) {
  if (!countryName) return null;
  const scope = document.querySelector(".market-switcher");
  if (!scope) return null;
  const names = Array.from(
    scope.querySelectorAll(".market-switcher-list li a")
  );
  const flags = Array.from(scope.querySelectorAll(".market-switcher-flag"));
  if (!names.length || names.length !== flags.length) return null;
  const index = names.findIndex(
    (item) => item.textContent.trim() === countryName
  );
  if (index === -1) return null;
  return flags[index].dataset.isoCode || null;
}

function getMarketNameFromIsoCode(isoCode) {
  if (!isoCode) return null;
  const scope = document.querySelector(".market-switcher");
  if (!scope) return null;
  const names = Array.from(
    scope.querySelectorAll(".market-switcher-list li a")
  );
  const flags = Array.from(scope.querySelectorAll(".market-switcher-flag"));
  if (!names.length || names.length !== flags.length) return null;
  const index = flags.findIndex((flag) => flag.dataset.isoCode === isoCode);
  if (index === -1) return null;
  return names[index].textContent.trim() || null;
}

function setCurrentCountry() {
  let locationSearch = window.location.search;
  if (locationSearch.includes("redirectCountry=")) {
    let locationSearchCountry = decodeURIComponent(
      window.location.search.split("&redirectCountry=")[1].split("&")[0]
    );
    if (locationSearchCountry != "") {
      if (localStorage.getItem("CurrentCountryWoodTrick")) {
        if (
          localStorage.getItem("CurrentCountryWoodTrick") !=
          locationSearchCountry
        ) {
          localStorage.setItem(
            "CurrentCountryWoodTrick",
            JSON.stringify(locationSearchCountry)
          );
        }
      } else {
        localStorage.setItem(
          "CurrentCountryWoodTrick",
          JSON.stringify(locationSearchCountry)
        );
      }
    }
    window.history.replaceState(
      {},
      "",
      window.location.href.split("&redirectCountry=")[0]
    );
  }
  if (localStorage.getItem("CurrentCountryWoodTrick")) {
    let currentCountry = JSON.parse(
      localStorage.getItem("CurrentCountryWoodTrick")
    );
	  const countryList = {
		  "Australia": "AU",
		  "United States": "US",
		  "Canada": "CA",
		  "Brazil": "BR",
		  "Poland": "PL",
		  "United Kingdom": "GB",
		  "France": "FR",
		  "Germany": "DE",
		  "Italy": "IT",
		  "Spain": "ES",
		  "Netherlands": "NL",
		  "Europe": "EU",
		  "World": "WORLD",
		  "South Korea": "KR"
	  }
	  const countryName = String(currentCountry || "").trim();
	  const currentIsoCode =
		  getIsoCodeFromSwitcher(countryName) || countryList[countryName] || null;

    if (!currentIsoCode) {
      localStorage.removeItem("CurrentCountryWoodTrick");
      return;
    }

    if (document.querySelector(".js-current-country-value")) {
      document.querySelector(
        ".js-current-country-value"
      ).innerHTML = `${countryName} <span class="arrow"></span>`;
    }
    if (document.querySelector(".js-market-switcher-label")) {
      document.querySelector(
        ".js-market-switcher-label"
      ).textContent = getMarketNameFromIsoCode(currentIsoCode) || countryName;
    }
    if (document.querySelectorAll(".market-switcher-flag")) {
      document.querySelectorAll(
        ".market-switcher-flag"
      ).forEach((flag) => {
        flag.classList.add("hidden");
        flag.setAttribute("hidden", "");
        flag.setAttribute("aria-hidden", "true");
      });

      document.querySelectorAll(
        `.market-switcher-flag[data-iso-code="${currentIsoCode}"]`
      ).forEach((flag) => {
        flag.classList.remove("hidden");
        flag.removeAttribute("hidden");
        flag.removeAttribute("aria-hidden");
      });
    }
  }
}
setCurrentCountry();

function setPreviewThumbSliderAriaLabels($sliders) {
  var previousLabel =
    (window.accessibilityStrings &&
      window.accessibilityStrings.previousSlide) ||
    "Previous slide";
  var nextLabel =
    (window.accessibilityStrings && window.accessibilityStrings.nextSlide) ||
    "Next slide";

  $sliders.each(function () {
    $(this).find(".slick-prev").attr("aria-label", previousLabel);
    $(this).find(".slick-next").attr("aria-label", nextLabel);
  });

  // Fallback for re-rendered preview arrows outside thumbs scope.
  $(".preview .slick-prev").attr("aria-label", previousLabel);
  $(".preview .slick-next").attr("aria-label", nextLabel);
}

function setCarouselSliderAriaLabels($sliders) {
  var previousLabel =
    (window.accessibilityStrings &&
      window.accessibilityStrings.previousSlide) ||
    "Previous slide";
  var nextLabel =
    (window.accessibilityStrings && window.accessibilityStrings.nextSlide) ||
    "Next slide";

  $sliders.each(function () {
    $(this).find(".slick-prev").attr("aria-label", previousLabel);
    $(this).find(".slick-next").attr("aria-label", nextLabel);
  });

  $(".carousel-box .slick-prev, .js-viewed-product .slick-prev").attr(
    "aria-label",
    previousLabel
  );
  $(".carousel-box .slick-next, .js-viewed-product .slick-next").attr(
    "aria-label",
    nextLabel
  );
}

$(function () {
  var $previewThumbs = $(".preview__thumbs");
  if (!$previewThumbs.length) {
    return;
  }

  $previewThumbs.on("init reInit", function () {
    setPreviewThumbSliderAriaLabels($(this));
  });

  setPreviewThumbSliderAriaLabels($previewThumbs.filter(".slick-initialized"));
  setTimeout(function () {
    setPreviewThumbSliderAriaLabels($previewThumbs);
  }, 0);
});

$(function () {
  var $carouselSliders = $(".carousel-box__list, .js-viewed-product-list");
  if (!$carouselSliders.length) {
    return;
  }

  $carouselSliders.on("init reInit", function () {
    setCarouselSliderAriaLabels($(this));
  });

  setCarouselSliderAriaLabels($carouselSliders.filter(".slick-initialized"));
  setTimeout(function () {
    setCarouselSliderAriaLabels($carouselSliders);
  }, 0);
});

$(".js-collection-reviews-slider")
  .not(".slick-initialized")
  .slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-prev" aria-label="Previous"><span class="slick-arrow-icon icon-arrow-left"></span></button>',
    nextArrow:
      '<button type="button" class="slick-next" aria-label="Next"><span class="slick-arrow-icon icon-arrow-right"></span></button>',
    dots: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 3,
          centerMode: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          arrows: false,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          arrows: false,
        },
      },
    ],
  });
$(".js-collection-reviews-slider.slick-initialized").on(
  "beforeChange",
  function (event, slick, currentSlide, nextSlide) {
    $(".js-collection-reviews-slider .video-poster").each(function () {
      let video = $(this).closest(".review-item-media").find("video");
      if (video.length > 0) {
        video[0].pause();
        $(this).show();
      }
    });
  }
);
$(".js-collection-reviews-slider .review-item-media").on("click", function () {
  let video = $(this).find("video");
  if ($(this).hasClass("is-playing")) {
    if (video.length > 0) {
      video[0].pause();
      $(this).closest(".review-item-media").find(".video-poster").show();
    }
  } else {
    if (video.length > 0) {
      video[0].play();
      $(this).closest(".review-item-media").find(".video-poster").hide();
    }
  }
  $(this).toggleClass("is-playing");
});
$(".site-description__text table").wrap(
  "<div class='site-description__table-wrapper'></div>"
);

let replacementSearchNext = document.querySelector(
  ".js-replacement-search-next"
);
if (replacementSearchNext) {
  replacementSearchNext.addEventListener("click", function () {
    if (!validateReplacementReason()) return;

    checkReplacmentRule();
  });
}

function validateReplacementReason() {
  const replacementForm = document.querySelector(".replacement-form-wrapper");
  const select = replacementForm?.querySelector(".js-replacement-reason");
  const group = replacementForm?.querySelector(".js-replacement-reason-group");
  const error = replacementForm?.querySelector("#ReplacementReasonError");
  const select2Selection = group?.querySelector(".select2-selection");
  const selectedValue = select?.value;
  const isValid = Boolean(selectedValue);

  if (!select || !group || !error) return true;

  group.classList.toggle("form-has-error", !isValid);
  select.toggleAttribute("aria-invalid", !isValid);
  error.hidden = isValid;

  if (select2Selection) {
    select2Selection.toggleAttribute("aria-invalid", !isValid);
    select2Selection.setAttribute("aria-describedby", error.id);
  }

  if (!isValid) {
    (select2Selection || select).focus();
  }

  return isValid;
}

$(document).on("change", ".js-replacement-reason", validateReplacementReason);

function checkReplacmentRule() {
  let replacementInformBox = document.querySelector(
    ".js-replacement-inform-box"
  );
  let replacementForm = document.querySelector(".replacement-form-wrapper");
  let replacementReasonSelect = replacementForm.querySelector(
    ".js-replacement-reason"
  );
  let replacementReasonId =
    replacementReasonSelect.options[replacementReasonSelect.selectedIndex]
      .value;
  if (
    replacementInformBox &&
    replacementForm.dataset.showReplacment == "false"
  ) {
    if (
      replacementReasonId == 1 ||
      replacementReasonId == 2 ||
      replacementReasonId == 5
    ) {
      if (replacementForm) {
        replacementForm.remove();
      }
      replacementInformBox.removeAttribute("style");
      window.history.replaceState(
        {},
        "",
        window.location.href.replace("?step=2", "")
      );
    }
  }
}

// Language and gift popups

const popupFocusState = new WeakMap();

const getFocusableElements = (container) => {
  if (!container) return [];
  const selector = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
  ].join(", ");

  return Array.from(container.querySelectorAll(selector)).filter((element) => {
    return (
      !element.hasAttribute("hidden") &&
      element.getAttribute("aria-hidden") !== "true" &&
      element.offsetParent !== null
    );
  });
};

const trapPopupFocus = (event, popup) => {
  if (event.key !== "Tab" || !popup.classList.contains("open")) return;
  const focusableElements = getFocusableElements(popup);
  if (!focusableElements.length) {
    event.preventDefault();
    return;
  }

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.shiftKey && document.activeElement === firstElement) {
    event.preventDefault();
    lastElement.focus();
  } else if (!event.shiftKey && document.activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
  }
};

const openPopup = (popup, backDrop, triggerElement) => {
	if (!popup || !backDrop || popup.classList.contains("open")) return;
	const popupContent = popup.querySelector('[tabindex="-1"]') || popup;
	popupFocusState.set(popup, triggerElement || document.activeElement);

	document.body.classList.add("is-scroll-hidden");
	popup.setAttribute("aria-hidden", "false");
	backDrop.classList.add("open");

	setTimeout(() => {
		popup.classList.add("open");
		const focusableElements = getFocusableElements(popup);
		if (focusableElements.length) {
			focusableElements[0].focus({ preventScroll: true });
		} else {
			popupContent.focus({ preventScroll: true });
		}
	}, 10);
};

const closePopup = (popup, backDrop) => {
	if (!popup || !backDrop) return;

	popup.classList.remove("open");
	popup.setAttribute("aria-hidden", "true");

	setTimeout(() => {
		backDrop.classList.remove("open");
	}, 300);

	document.body.classList.remove("is-scroll-hidden");

	const triggerElement = popupFocusState.get(popup);
	if (triggerElement && typeof triggerElement.focus === "function") {
		triggerElement.focus({ preventScroll: true });
	}
};

const submitForm = () => {
  const form = document.querySelector("#language-popup #localization_form");
  if (!form) return;
  const select = form.querySelector("#language-popup .js-language-select");
  const button = form.querySelector(".language-popup__button");

  select.removeAttribute("onchange");
  $(select).off("change");

  $(select).on("select2:select", function (e) {
    console.log("Select2 changed to:", e.params.data.id);
  });

  button.addEventListener("click", function (e) {
    e.preventDefault();
    localStorage.setItem("languagePopupShown", "true");
    form.submit();
  });
};
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("language-popup");
  if (!popup) return;
  const backDrop = document.getElementById("language-popup-bg");
  const closeBtn = popup.querySelector("[data-modal-close]");
  const POPUP_KEY = "languagePopupShown";

  if (!localStorage.getItem(POPUP_KEY)) {
    openPopup(popup, backDrop, document.activeElement);
  }

  backDrop.addEventListener("click", () => {
    closePopup(popup, backDrop);
  });
  closeBtn?.addEventListener("click", () => {
    closePopup(popup, backDrop);
  });
  popup.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      closePopup(popup, backDrop);
      return;
    }
    trapPopupFocus(event, popup);
  });
  submitForm();
});

// Gift cart popup

const popupDropdown = () => {
  const dropdown = document.getElementById("gift-card-list");
  if (!dropdown) return;
  const selected = document.getElementById("gift-card-selected");
  const textEl = selected.querySelector(".gift-card-text");
  const items = dropdown.querySelectorAll(".gift-card-item");
  const arrow = selected.querySelector(".gift-card-arrow");

  selected.addEventListener("click", () => {
    dropdown.classList.toggle("open");
    arrow.textContent = dropdown.classList.contains("open") ? "▲" : "▼";
  });

  items.forEach((item) => {
    item.addEventListener("click", () => {
      items.forEach((i) => i.classList.remove("selected"));
      item.classList.add("selected");
      textEl.textContent = item.textContent.trim();
      dropdown.classList.remove("open");
      arrow.textContent = "▼";
    });
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".gift-card-select-wrapper")) {
      dropdown.classList.remove("open");
      arrow.textContent = "▼";
    }
  });
};

const isGiftActive = () => {
  const checkbox = document.querySelector("#gift-cart-checkbox");
  if (!checkbox) return;
  const popup = document.querySelector("#gift-popup");
  const popupBg = document.querySelector("#gift-popup-bg");
  const closeBtn = popup?.querySelector("[data-gift-modal-close]");

  if (checkbox.checked) {
    openPopup(popup, popupBg, checkbox);
  }

  popupBg.addEventListener("click", () => {
    closePopup(popup, popupBg);
  });
  closeBtn?.addEventListener("click", () => {
    closePopup(popup, popupBg);
  });
  popup?.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      closePopup(popup, popupBg);
      return;
    }
    trapPopupFocus(event, popup);
  });
};

function mountGiftPopupToBody() {
  var popup = document.getElementById("gift-popup");
  var bg = document.getElementById("gift-popup-bg");
  if (!popup || !bg) return;
  if (popup.parentElement === document.body && bg.parentElement === document.body) return;
  document.body.appendChild(bg);
  document.body.appendChild(popup);
}

document.addEventListener("DOMContentLoaded", () => {
  mountGiftPopupToBody();
  popupDropdown();
  // isGiftActive();
});

function focusScrollTarget(target) {
  if (!target) return;

  const hadTabindex = target.hasAttribute("tabindex");

  if (!hadTabindex) {
    target.setAttribute("tabindex", "-1");
  }

  target.focus({ preventScroll: true });

  if (!hadTabindex) {
    target.addEventListener(
      "blur",
      () => {
        target.removeAttribute("tabindex");
      },
      { once: true }
    );
  }
}

function getHeaderHeight() {
	const header = document.querySelector("#shopify-section-header, .header");
	return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
}

function syncHeaderHeight() {
	const headerHeight = getHeaderHeight();

	document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

const syncHeaderHeightDebounced = debounce(syncHeaderHeight, 100);

function initHeaderHeightSync() {
	syncHeaderHeight();
	window.requestAnimationFrame(syncHeaderHeight);
	window.addEventListener("resize", syncHeaderHeightDebounced);
	window.addEventListener("load", syncHeaderHeight);

	const header = document.querySelector("#shopify-section-header, .header");
	if (header && "ResizeObserver" in window) {
		new ResizeObserver(syncHeaderHeightDebounced).observe(header);
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initHeaderHeightSync, { once: true });
} else {
	initHeaderHeightSync();
}

function scrollToTargetWithFocus(target, hash) {
  if (!target) return;

  const headerHeight = getHeaderHeight();
  const targetTop = Math.max(
    target.getBoundingClientRect().top + window.scrollY - headerHeight,
    0
  );
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (hash) {
    window.history.replaceState(null, "", hash);
  }

  window.scrollTo({
    top: targetTop,
    behavior: prefersReducedMotion ? "auto" : "smooth",
  });

  window.setTimeout(
    () => {
      focusScrollTarget(target);
    },
    prefersReducedMotion ? 0 : 450
  );
}

document.addEventListener(
  "click",
  (event) => {
    const link = event.target.closest(".scroll-link");

    if (!link) return;
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (window.location.hostname !== link.hostname) return;

    const target = document.querySelector(link.hash);

    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    scrollToTargetWithFocus(target, link.hash);
  },
  true
);

function openReviewsSection() {
  const target = document.querySelector("#reviews-section");
  if (!target) return;

  setTimeout(() => {
    scrollToTargetWithFocus(target, "#reviews-section");
  }, 60);
}


// Product card video

document.addEventListener("DOMContentLoaded", function() {
	if (window.matchMedia("(hover: hover)").matches) {
		const productCards = document.querySelectorAll('.carousel-card__link');

		productCards.forEach(card => {
			card.addEventListener('mouseenter', function() {
				const video = this.querySelector('.carousel-card__video');
				if (video) {
					video.play().catch(error => {
						console.log("Video autoplay rejected by browser:", error);
					});
				}
			});

			card.addEventListener('mouseleave', function() {
				const video = this.querySelector('.carousel-card__video');
				if (video) {
					video.pause();
					video.currentTime = 0;
				}
			});
		});
	}
});

$(document).ready(function() {
	setTimeout(function() {
		$('.select2-selection').removeAttr('aria-controls');
	}, 500);
});

$(document).ready(function() {
	function fixSelect2Accessibility() {
		var $select2Elements = $('.select2-selection');

		if ($select2Elements.length > 0) {
			$select2Elements.each(function() {
				var $selection = $(this);
				var $select = $selection.closest('.select2-container').siblings('select');
				var selectedOption = $select.find('option:selected')[0];
				var fullLabel = selectedOption ? selectedOption.getAttribute('data-full-label') : null;

				$selection.attr('tabindex', '0');
				$selection.removeAttr('aria-controls');

				if ($select.hasClass('js-language-select') && fullLabel) {
					$selection.attr('aria-label', fullLabel);
				}
			});

			$select2Elements.off('keydown.a11y').on('keydown.a11y', function(e) {
				if (e.keyCode === 13 || e.keyCode === 32) {
					e.preventDefault();

					var $select = $(this).closest('.select2-container').siblings('select');
					if ($select.length) {
						$select.select2('open');
					}
				}
			});
		}
	}

	setTimeout(fixSelect2Accessibility, 500);
	$(document).on('change select2:select', '.js-language-select', fixSelect2Accessibility);
});

$(document).ready(function () {
	var HEADER_MENU_DESKTOP_MIN = 992;
	var $menuBlock = $('.menu');

	if (!$menuBlock.length) {
		return;
	}

	var $body = $('body');
	var $backdrop = $menuBlock.find('.menu__backdrop');
	var $menuItemStyled = $menuBlock.find('.menu__item_styled');
	var $collapseItem = $menuBlock.find('[data-toggle]');

	function bindDesktopMenuHover() {
		$menuItemStyled.each(function (i, item) {
			var $item = $(item);
			var $link = $item.find('.menu__item-link');

			$item.on('mouseenter.headerWtcustom', function () {
				$item.addClass('active');
				$backdrop.addClass('show');
				window.setTimeout(function () {
					$item.addClass('is-show');
				}, 50);
			});

			$item.on('mouseleave.headerWtcustom', function () {
				$backdrop.removeClass('show');
				$item.removeClass('is-show is-touched');
				$item.data('is-touch-event', false);
				window.setTimeout(function () {
					$item.removeClass('active');
				}, 200);
			});

			$link.on('touchstart.headerWtcustom', function() {
				$item.data('is-touch-event', true);
			});

			$link.on('click.headerWtcustom', function (e) {
				if ($item.data('is-touch-event') && !$item.hasClass('is-touched')) {
					e.preventDefault();

					$menuItemStyled.removeClass('is-touched active is-show');
					$item.addClass('is-touched active');
					$backdrop.addClass('show');
					window.setTimeout(function () {
						$item.addClass('is-show');
					}, 50);
				}
				$item.data('is-touch-event', false);
			});
		});
	}

	function syncHeaderMainMenuMode() {
		var windowWidth = window.innerWidth || document.documentElement.clientWidth;

		$menuItemStyled.off('mouseenter.headerWtcustom mouseleave.headerWtcustom');
		$menuItemStyled.find('.menu__item-link').off('touchstart.headerWtcustom click.headerWtcustom');

		if (windowWidth < HEADER_MENU_DESKTOP_MIN) {
			$collapseItem.attr('data-toggle', 'collapse');
			$menuItemStyled.removeClass('active is-show is-touched');
			$backdrop.removeClass('show');
		} else {
			$body.removeClass('menu-opened menu-show');
			$collapseItem.attr('data-toggle', '');
			bindDesktopMenuHover();
		}
	}

	syncHeaderMainMenuMode();
	$(window).on('resize', debounce(syncHeaderMainMenuMode, 400));
});

$(document).ready(function () {
	var HEADER_SEARCH_TOP_MAX_WIDTH = 991;
	var $headerSearch = $('.header__search').first();

	if (!$headerSearch.length) {
		return;
	}

	var $headerTop = $('.header__top').first();
	var $headerSearchBackdrop = $headerSearch.find('.header__search-backdrop');
	var $headerToggleScope = $headerSearch.closest(
		'.header__aside-item_search, .header__aside, .header__inner, [id^="shopify-section"]'
	);

	if (!$headerToggleScope.length) {
		$headerToggleScope = $(document.body);
	}

	function updateHeaderSearchBlockPosition() {
		var windowWidth =
			window.innerWidth || document.documentElement.clientWidth;

		if (windowWidth <= HEADER_SEARCH_TOP_MAX_WIDTH) {
			var height = $headerTop.length ? $headerTop.outerHeight() : 0;
			$headerSearch.css('top', height + 'px');
			if ($headerSearchBackdrop.length) {
				$headerSearchBackdrop.css(
					'top',
					height + $headerSearch.outerHeight() + 'px'
				);
			}
		} else {
			$headerSearch.css('top', '');
			$headerSearchBackdrop.css('top', '');
		}
	}

	updateHeaderSearchBlockPosition();
	$(window).on('resize', debounce(updateHeaderSearchBlockPosition, 150));

	$headerToggleScope.on(
		'click.headerSearchTop',
		'.header__search-toggle, .header__search-input-label',
		function () {
			window.requestAnimationFrame(updateHeaderSearchBlockPosition);
			window.setTimeout(updateHeaderSearchBlockPosition, 300);
		}
	);
});

$(document).ready(function() {
	function getHeaderMenuLiveRegion() {
		var liveRegion = document.getElementById('HeaderMenuLiveRegion');

		if (!liveRegion) {
			liveRegion = document.createElement('div');
			liveRegion.id = 'HeaderMenuLiveRegion';
			liveRegion.className = 'sr-only';
			liveRegion.setAttribute('role', 'status');
			liveRegion.setAttribute('aria-live', 'assertive');
			liveRegion.setAttribute('aria-atomic', 'true');
			document.body.appendChild(liveRegion);
		}

		return liveRegion;
	}

	function getHeaderMenuItemLabel($menuLink) {
		var $linkClone = $menuLink.clone();

		$linkClone.find('.menu__item-icon').remove();

		return $linkClone.text().replace(/\s+/g, ' ').trim();
	}

	function formatHeaderMenuSubmenuOpened(label) {
		var tpl = typeof window.themeAccessibility !== 'undefined' && window.themeAccessibility.headerMenuSubmenuOpenedTemplate;
		var placeholder = '__WT_MENU_ITEM__';

		if (tpl && tpl.indexOf(placeholder) !== -1) {
			return tpl.split(placeholder).join(label);
		}

		return label + ' submenu opened';
	}

	function announceHeaderMenuOpened(label) {
		var liveRegion = getHeaderMenuLiveRegion();

		if (!label) return;

		liveRegion.textContent = '';
		window.setTimeout(function() {
			liveRegion.textContent = formatHeaderMenuSubmenuOpened(label);
		}, 100);
	}

	$('.menu__item').has('.menu__submenu').on('mouseenter.a11y', function() {
		var $menuLink = $(this).find('.menu__item-link').first();
		var label = getHeaderMenuItemLabel($menuLink);

		$menuLink.attr('aria-expanded', 'true');
		announceHeaderMenuOpened(label);
	});

	$('.menu__item').has('.menu__submenu').on('mouseleave.a11y', function() {
		$(this).find('.menu__item-link').first().attr('aria-expanded', 'false');
	});

	$('.menu__item-link').on('keydown', function(e) {
		if (e.key === ' ' || e.key === 'Enter') {
			e.preventDefault();

			var $parentLi = $(this).closest('.menu__item_styled');

			if ($parentLi.hasClass('active')) {
				$parentLi.trigger('mouseleave');
				$(this).attr('aria-expanded', 'false');
			} else {
				$('.menu__item_styled.active').trigger('mouseleave').find('.menu__item-link').attr('aria-expanded', 'false');

				$parentLi.trigger('mouseenter');
				$(this).attr('aria-expanded', 'true');
			}
		}
	});

	$(document).on('keydown', function(e) {
		if (e.key === 'Escape') {
			var $activeMenu = $('.menu__item_styled.active');
			if ($activeMenu.length) {
				$activeMenu.trigger('mouseleave');
				$activeMenu.find('.menu__item-link').attr('aria-expanded', 'false');
				$activeMenu.find('.menu__item-link').focus();
			}
		}
	});

	$('.menu__item_styled').on('focusout', function() {
		var $parentLi = $(this);
		setTimeout(function() {
			if (!$parentLi.has(document.activeElement).length) {
				$parentLi.trigger('mouseleave');
				$parentLi.find('.menu__item-link').attr('aria-expanded', 'false');
			}
		}, 10);
	});
});

// Знаходимо ваш контейнер зі слайдером
const $slider = $('.carousel-box__list');

$slider.on('init', function(event, slick) {
	$(slick.$slides).find('.slide-card').attr('tabindex', '-1');
	$(slick.$slides).filter('.slick-active').find('.slide-card').attr('tabindex', '0');
});

$slider.on('afterChange', function(event, slick, currentSlide) {
	$(slick.$slides).find('.slide-card').attr('tabindex', '-1');
	$(slick.$slides).filter('.slick-active').find('.slide-card').attr('tabindex', '0');
});


// Geo redirect popup
// On the US store, if the visitor's IP country matches the target ISO (GB),
// offer to stay on the US store or switch to the UK store. Shown once (localStorage).
function mountGeoPopupToBody() {
	const popup = document.getElementById("geo-popup");
	const bg = document.getElementById("geo-popup-bg");
	if (!popup || !bg) return;
	if (popup.parentElement !== document.body) document.body.appendChild(popup);
	if (bg.parentElement !== document.body) document.body.appendChild(bg);
}

function initGeoRedirectPopup() {
	const popup = document.getElementById("geo-popup");
	if (!popup) return;

	const POPUP_KEY = "geoRedirectPopupShown";
	try {
		if (localStorage.getItem(POPUP_KEY)) return;
	} catch (e) {
		/* localStorage unavailable - just show the popup */
	}

	// Only act on the US store, never on the EU/UK store itself.
	if (window.location.hostname.indexOf("eu.woodtrick.com") !== -1) return;

	const targetIso = (popup.dataset.targetIso || "GB").toUpperCase();
	const redirectUrl = popup.dataset.redirectUrl;
	const bg = document.getElementById("geo-popup-bg");
	const closeBtn = popup.querySelector("[data-geo-modal-close]");
	const stayBtn = popup.querySelector("[data-geo-stay]");
	const leaveBtn = popup.querySelector("[data-geo-leave]");

	const markShown = () => {
		try { localStorage.setItem(POPUP_KEY, "true"); } catch (e) { /* ignore */ }
	};
	const dismiss = () => {
		markShown();
		closePopup(popup, bg);
	};

	fetch("https://get.geojs.io/v1/ip/country.json")
		.then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
		.then((data) => {
			const country = (data && data.country ? data.country : "").toUpperCase();
			if (country !== targetIso) return;

			openPopup(popup, bg, document.activeElement);

			bg.addEventListener("click", dismiss);
			popup.addEventListener("click", (event) => {
				if (event.target === popup) dismiss();
			});
			closeBtn?.addEventListener("click", dismiss);
			stayBtn?.addEventListener("click", dismiss);
			leaveBtn?.addEventListener("click", () => {
				markShown();
				if (redirectUrl) window.location.href = redirectUrl;
			});
			popup.addEventListener("keydown", (event) => {
				if (event.key === "Escape") {
					event.preventDefault();
					dismiss();
					return;
				}
				trapPopupFocus(event, popup);
			});
		})
		.catch(() => { /* geolocation failed - do not show the popup */ });
}

document.addEventListener("DOMContentLoaded", () => {
	mountGeoPopupToBody();
	initGeoRedirectPopup();
});
